import styles from "./SettingsCategories.module.scss";
import Card from "../../../../common/Card";
import CardEmpty from "../../../../common/CardEmpty";
import useSettingsCategories from "./useSettingsCategories";
import React from "react";
import {MODE_CREATE, MODE_EDIT} from "../../../../codes";
import {CategoryEditor} from "../editor/CategoryEditor";
import clsx from "clsx";
import {HeaderMenuActionDropdown, HeaderMenuActionDropdownItem, HeaderMenuLeft} from "../../../../common/HeaderMenu";
import useProject from "../../../../util/useProject";
import {FabButton} from "../../../../common/FabButton";
import {Content, ContentFixed} from "../../../../common/Content";
import {SettingsMenuMobile} from "../../Settings";
import {SettingsContent} from "../../SettingsContent";
import {SettingsTopMenu} from "../../SettingsTopMenu";

const SettingsCategories = () => {
  const {runWithExpiration} = useProject();

  const {
    t,
    transactionCategories,
    transactionsCount,
    groups,
    showCategoryEditor,
    inactiveCategories,
    toggleInactiveCategories
  } = useSettingsCategories();

  return (
    <Content>
      <ContentFixed>
        <SettingsTopMenu title="header_title_settings_categories">
          <HeaderMenuLeft>
            <HeaderMenuActionDropdown label={t("menu_display")}>
              <HeaderMenuActionDropdownItem
                icon={inactiveCategories ? "check_box" : "check_box_outline_blank"}
                onClick={toggleInactiveCategories}
                enabled
                label={t("menu_show_inactive_categories")}
              />
            </HeaderMenuActionDropdown>
          </HeaderMenuLeft>
        </SettingsTopMenu>

        <SettingsMenuMobile/>
      </ContentFixed>

      <SettingsContent withFab={true}>
        <FabButton onClick={runWithExpiration(() => showCategoryEditor(MODE_CREATE, {}))}/>

        <Card ifCond={!transactionCategories.length}>
          <CardEmpty>{t("no_transaction_categories")}</CardEmpty>
        </Card>

        {groups.map(group => {
          return <Card key={group.groupName} title={group.groupName}>
            {group.categories.map(transactionCategory => {
              const [background, color] = transactionCategory.color.split("|");

              return <div className={styles.category} key={transactionCategory.id}>
                <div className={clsx(styles.categoryDetails, "hover-selectable")}
                     onClick={runWithExpiration(() => showCategoryEditor(MODE_EDIT, transactionCategory))}
                >
                  <div className={styles.categoryColor} style={{background}}>
                    <span className="material-icons" style={{color}}>{transactionCategory.icon}</span>
                  </div>
                  <div className={styles.categoryName}>
                    {transactionCategory.name}

                    {!transactionCategory.active &&
                      <span className={clsx("material-icons", styles.inactiveIcon)}>visibility_off</span>}
                  </div>
                  <div className={styles.categoryDescription}>{transactionCategory.description}</div>
                  <div className={styles.transactionsCount}>
                    {t("nb_transactions", {count: transactionsCount[transactionCategory.id]})}
                  </div>
                </div>
              </div>;
            })}
          </Card>;
        })}
      </SettingsContent>

      <CategoryEditor/>
    </Content>
  );
};

export default SettingsCategories;
